export function transformWorkflowData(workflowData, colorsList) {
  if (!workflowData || !workflowData.text_diagram) {
    return { nodes: [], edges: [] };
  }

  const lines = workflowData.text_diagram
    .split('\n')
    .filter(line => line.trim());
  const nodes = [];
  const edges = [];
  const nodeMap = new Map();

  let nodeId = 0;
  let xPosition = 0;
  const positionGapX = 250; // Increased horizontal spacing
  const positionGapY = 100; // Reduced vertical spacing for horizontal layout

  const nodeTypeColorIndexMap = {
    start: 0,
    agent: 1,
    user: 2,
    decision: 3,
    end: 4,
    default: 5,
  };

  // Parse lines to create nodes
  lines.forEach((line, index) => {
    const trimmedLine = line.trim();

    // Skip empty lines and flow indicators
    if (
      !trimmedLine ||
      trimmedLine === '⬇️' ||
      trimmedLine === 'v' ||
      trimmedLine === '|'
    ) {
      return;
    }

    // Skip title line
    if (trimmedLine.includes('Flowchart:') || index === 0) {
      return;
    }

    let nodeType = 'default';
    let nodeStyle = 'default';
    let nodeLabel = trimmedLine;

    // Determine node type and style
    if (trimmedLine === 'Start') {
      nodeType = 'start';
      nodeStyle = 'start';
    } else if (trimmedLine === 'End') {
      nodeType = 'end';
      nodeStyle = 'end';
    } else if (trimmedLine.includes('User:')) {
      nodeType = 'user';
      nodeStyle = 'user';
      nodeLabel = trimmedLine.replace('User:', '').trim().replace(/["""]/g, '');
    } else if (trimmedLine.includes('Agent:')) {
      nodeType = 'agent';
      nodeStyle = 'agent';
      nodeLabel = trimmedLine
        .replace('Agent:', '')
        .trim()
        .replace(/["""]/g, '');
    } else if (trimmedLine.includes('Decision:')) {
      nodeType = 'decision';
      nodeStyle = 'decision';
    }

    const id = `node_${nodeId}`;
    nodeId += 1;
    const colorIndex =
      nodeTypeColorIndexMap[nodeStyle] || nodeTypeColorIndexMap.default;

    // Calculate horizontal position - alternate between top and bottom for better flow
    const x = xPosition;
    const y = nodeId % 2 === 0 ? 0 : positionGapY; // Alternate between top and bottom
    xPosition += positionGapX;

    const node = {
      id,
      type: 'default',
      position: { x, y },
      data: {
        label: nodeLabel,
        originalType: nodeType,
      },
      style: {
        backgroundColor: colorsList[colorIndex] || '#6B7280',
        color: 'white',
        border: 'none',
        borderRadius: '10px',
        fontWeight: 'bold',
        padding: '10px 15px',
        fontSize: '12px',
        minWidth: '120px',
        textAlign: 'center',
      },
    };

    nodes.push(node);
    nodeMap.set(index, id);

    // Create edges between consecutive nodes
    if (nodes.length > 1) {
      const previousNode = nodes[nodes.length - 2];
      edges.push({
        id: `edge_${edges.length}`,
        source: previousNode.id,
        target: id,
        type: 'smoothstep',
        animated: true,
        style: {
          stroke: '#6B7280',
          strokeWidth: 2,
        },
      });
    }
  });

  return { nodes, edges };
}

export function parseWorkflowSteps(textDiagram) {
  if (!textDiagram) return [];

  const lines = textDiagram.split('\n');

  return lines
    .map(line => line.trim())
    .filter(line => line.startsWith('User:') || line.startsWith('Agent:'))
    .map(line => {
      if (line.startsWith('User:')) {
        return {
          type: 'user',
          message: line.replace('User:', '').trim().replace(/["""]/g, ''),
        };
      }
      return {
        type: 'agent',
        message: line.replace('Agent:', '').trim().replace(/["""]/g, ''),
      };
    });
}
